import { render, staticRenderFns } from "./logisticsInvPortal.vue?vue&type=template&id=9c8300a6&scoped=true"
import script from "./logisticsInvPortal.vue?vue&type=script&lang=js"
export * from "./logisticsInvPortal.vue?vue&type=script&lang=js"
import style0 from "./logisticsInvPortal.vue?vue&type=style&index=0&id=9c8300a6&prod&lang=css"
import style1 from "./logisticsInvPortal.vue?vue&type=style&index=1&id=9c8300a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8300a6",
  null
  
)

export default component.exports